'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = require('components/ReactSlick/react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _lodash = require('lodash');

var _SlideWithQR = require('./SlideWithQR');

var _SlideWithQR2 = _interopRequireDefault(_SlideWithQR);

require('./slick.less');

require('./slick-theme.less');

require('./SliderWithQR.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SliderWithQRView: {
        displayName: 'SliderWithQRView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/SliderWithQR/default/SliderWithQRView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

// id таймера автоплея
var timerId = void 0;
// список продуктов, которые ожидают обновления
var _preparedItemsForUpdate = null;

var SliderWithQRView = _wrapComponent('SliderWithQRView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SliderWithQRView, _Component);

    function SliderWithQRView(props) {
        (0, _classCallCheck3.default)(this, SliderWithQRView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SliderWithQRView.__proto__ || (0, _getPrototypeOf2.default)(SliderWithQRView)).call(this));

        _this.checkForPreparedAndUpdate = _this.checkForPreparedAndUpdate.bind(_this);
        // Передаем в стейт, чтобы можно было контролировать обновление списка

        if (!(typeof _this.checkForPreparedAndUpdate === 'function')) {
            throw new TypeError('Value of "this.checkForPreparedAndUpdate" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.checkForPreparedAndUpdate));
        }

        _this.state = {
            items: props.items
        };
        return _this;
    }

    (0, _createClass3.default)(SliderWithQRView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.stopAutoplay();
            this.startAutoplay();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nProps) {
            // Если список обновлися свыше
            if (!(0, _lodash.isEqual)(nProps.items, this.state.items)) {
                // Если текущий список пустой
                if (!Array.isArray(this.state.items) || !this.state.items.length) {
                    return this.setState({
                        items: nProps.items
                    });
                }
                // Подготовливаем к след. тику обновления
                _preparedItemsForUpdate = nProps.items;
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nProp, nState) {
            // Не обновляем если ничего не поменялось
            return !(0, _lodash.isEqual)(this.state, nState);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.stopAutoplay();
            this.startAutoplay();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopAutoplay();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var items = this.state.items;
            // Свои классы применяеются только на внутреннем span, на внешний - слайдер
            // навешивает свое барахло

            var prevArrow = _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(
                    'span',
                    { className: 'SliderWithQR__prev-arrow' },
                    _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: 'Prev Slide' })
                )
            );

            var nextArrow = _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(
                    'span',
                    { className: 'SliderWithQR__next-arrow' },
                    _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: 'Next Slide' })
                )
            );
            var slideCount = this.props.count || 3;
            var sliderON = true;
            if (items.length === 1) {
                sliderON = false;
            }

            var settings = {
                arrows: sliderON,
                className: 'SlickSlider SliderWithQR__slick-slider u-full-height',
                centerMode: false,
                dots: false,
                infinite: sliderON,
                lazyLoad: false,
                // Реализуем сами, чтобы можно было сделать паузу
                autoplay: false,
                // autoplaySpeed: this.props.autoplaySpeed,

                // responsive: [
                //         { breakpoint: 480, settings: { slidesToShow: 1 } },
                //         { breakpoint: 768, settings: { slidesToShow: 1 } },
                //         { breakpoint: 992, settings: { slidesToShow: 1 } },
                //         { breakpoint: 12000, settings: { slidesToShow: slideCount } },
                //     ],
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                speed: 500, //?
                slidesToShow: slideCount,
                slidesToScroll: 1,
                swipeToSlide: sliderON,
                // После смены слайда(конец анимации) делаем обновление списка, если возможно
                afterChange: this.checkForPreparedAndUpdate
            };
            if (items.length === 0) {
                return null;
            }

            return _react3.default.createElement(
                'div',
                { className: 'SliderWithQR u-full-height' },
                _react3.default.createElement(
                    _reactSlick2.default,
                    (0, _extends3.default)({ ref: function ref(s) {
                            return _this2.slickSliderComponent = s;
                        } }, settings),
                    items.map(function (item, i) {
                        return _react3.default.createElement(
                            'div',
                            { className: 'SliderWithQR__slide u-full-height', key: item.$uid },
                            _react3.default.createElement(_SlideWithQR2.default, { product: item, updateProducts: _this2.props.updateProducts })
                        );
                    })
                )
            );
        }
    }, {
        key: 'startAutoplay',
        value: function startAutoplay() {
            var _this3 = this;

            if (!this.props.autoplay) {
                return;
            }

            timerId = setTimeout(function () {
                return _this3.nextSlide(), _this3.startAutoplay();
            }, this.props.autoplaySpeed);
        }
    }, {
        key: 'stopAutoplay',
        value: function stopAutoplay() {
            clearTimeout(timerId);
        }
    }, {
        key: 'nextSlide',
        value: function nextSlide() {
            this.slickSliderComponent.slickNext();
        }
    }, {
        key: 'prevSlide',
        value: function prevSlide() {
            this.slickSliderComponent.slickPrev();
        }
    }, {
        key: 'checkForPreparedAndUpdate',
        value: function checkForPreparedAndUpdate() {
            if (_preparedItemsForUpdate !== null) {
                this.setState({
                    items: _preparedItemsForUpdate
                });

                _preparedItemsForUpdate = null;
            }
        }
    }]);
    return SliderWithQRView;
}(_react2.Component), _class.propTypes = {
    items: _propTypes2.default.array,
    count: _propTypes2.default.number,
    autoplay: _propTypes2.default.bool,
    autoplaySpeed: _propTypes2.default.number,
    updateProducts: _propTypes2.default.func
}, _temp));

exports.default = SliderWithQRView;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderWithQR/default/SliderWithQRView.jsx
// module id = 1770
// module chunks = 0